import PipelineStatusChip from 'new/components/pipelines/PipelineStatusChip/PipelineStatusChip';
import { SourceName } from 'new/elements/SourceName';
import { Column } from 'new/elements/Table/types';
import { FlatFlow } from 'new/entities/FlatFlow';
import { shouldHideRecordsForResource } from 'js/lib/PipelineUtils';
import { bytesToString, formatNamedNumber } from 'js/lib/FormatUtils';
import React from 'react';

export const columns = [
  {
    name: 'Flow',
    field: 'root.name',
    sortable: true,
    renderRow: (row) => (
      <SourceName
        title={row.leafConnectionName}
        type="source"
        chipTitle="FLOW"
        icon={row.root.icon}
        name={row.root.name}
        id={row.root.flow_node_id}
      />
    ),
    width: 22,
  },
  {
    name: 'Destination/Nexset',
    field: 'org',
    renderRow: (row) => (
      <SourceName
        title={row.leafConnectionName}
        type={row.isLeafSink ? 'source' : 'nexset'}
        icon={row.leaf?.icon}
        name={row?.leaf?.name}
      />
    ),
    width: 22,
  },
  {
    name: 'Status',
    field: 'root.statusInfo.name',
    center: true,
    sortable: true,
    renderRow: (row) => {
      return (
        <PipelineStatusChip
          id={row.root.flow_node_id ?? row.root.id}
          status={row.root.status}
          archivalStatus={row.root.archival_status}
          showRuntimeIndicator={false}
          className={row.root.status?.toLowerCase() ?? ''}
        />
      );
    },
  },
  {
    name: 'Source records',
    field: 'sourceRecordCount',
    sortable: true,
    numeric: true,
    renderRow: (row: FlatFlow) => {
      const hideRecords = shouldHideRecordsForResource(row.root);
      if (hideRecords) {
        return bytesToString(row.sourceRecordVolume);
      }
      return formatNamedNumber(row.sourceRecordCount);
    },
  },
  {
    name: 'Destination records',
    field: 'sinkRecordCount',
    numeric: true,
    renderRow: (row: FlatFlow) => {
      const hideRecords = shouldHideRecordsForResource(row.root);
      if (hideRecords) {
        return bytesToString(row.sinkRecordVolume);
      }
      return formatNamedNumber(row.sinkRecordCount);
    },
  },
  {
    name: 'Source errors',
    field: 'sourceErrorCount',
    numeric: true,
  },
  {
    name: 'Destination errors',
    field: 'sinkErrorCount',
    numeric: true,
  },
] as Column<FlatFlow>[];
